import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";


@Component({
    selector: 'page-data-log',
    templateUrl: 'data-log.html',
})
export class DataLogPage {

    FWebEnquiryId: any;
    DataLogs:any;
    DataId:any;

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public platform: Platform,
                public loadingCtrl:LoadingController,
                public viewCtrl:ViewController,
                public service: ServiceProvider) {

        this.platform.ready().then(() => {
            this.FWebEnquiryId = navParams.get('FWebEnquiryId');
            this.DataId=navParams.get('DataId');
            console.log("this.FWebEnquiryId -> ", this.FWebEnquiryId);
            this.loadData(this.FWebEnquiryId);
        })

    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad DataLogPage');
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    loadData(FWebEnquiryId) {
        let loading = this.loadingCtrl.create({
            content: 'Loading'
        });
        loading.present();
        this.DataLogs=[];
        this.service.httpcall('app_web_service/get_daily_logs_by_FWebEnquiryId?FWebEnquiryId=' + FWebEnquiryId).subscribe(data => {
            loading.dismiss();
            console.log(data);
            if (data['response'] == "success") {
                this.DataLogs=data['data'];
            } else {
                this.service.showAlert('Error!',data['error_description']);
            }
        },error=>{
            this.service.showAlert('Error!','Timeout');
        })

    }

    doRefresh(refresher) {
        console.log('Begin async operation', refresher);
        this.loadData(this.FWebEnquiryId);
        setTimeout(() => {
            console.log('Async operation has ended');
            refresher.complete();
        }, 2000);
    }
}



// WEBPACK FOOTER //
// ./src/pages/data-log/data-log.ts